import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UploadData.css'
const Data = ({ orgId }) => {
   // Define class options for different organizations
   const classOptionsByOrg = {
    "c6e5df83-282a-4bee-aa4d-f3d90c12615f": [
      { label: "Class 6A", value: "db239250-310f-4a79-b81d-86b3af9f79b4" },
      { label: "Class 6B", value: "e00f1b80-c940-4dc2-a763-678fde977254" },
      { label: "Class 6C", value: "dd24b005-71d8-46c1-bca2-848b4c97738e" },
      { label: "Class 7A", value: "bff12285-2e3f-483e-a717-961ede7dad09" },
      { label: "Class 7B", value: "94d6e73a-6c2d-43ce-9492-bbe93638df77" },
      { label: "Class 7C", value: "ba44d914-6bfa-4268-b86d-8addf4dd73a4" },
      { label: "Class 8A", value: "7d8ea199-a39a-4bcf-8171-252fce5e3a30" },
      { label: "Class 8B", value: "0802c052-f8f4-4fac-966e-b4a037dae4e4" },
      { label: "Class 8C", value: "ba701a5d-0592-49ce-8999-54ac8435e2cf" },
      { label: "Class 9A", value: "43e11e24-39e7-41be-b866-843364f3809e" },
      { label: "Class 9B", value: "abb20c90-1ff2-4472-aa7e-fb92f3bcb260" },
      { label: "Class 9C", value: "bac5ee30-eec7-4dcc-8bf5-f1dd7aaa800d" },
      { label: "Class 10A", value: "98700b0f-5d49-420b-9181-698e5bb1242b" },
      { label: "Class 10B", value: "b4a4946d-2952-4b74-8b8c-282c436ecfd0" },
      { label: "Class 10C", value: "b51f851f-5866-4d2c-8e48-0ab6e42a30c1" },
    ],
    "d476a6ea-e7fd-44f9-85ff-4d9ed0ed9a46": [
      { label: "Class 6A", value: "680be44b-3791-4922-8860-f8ce2bbcc018" },
      { label: "Class 6B", value: "439f0f6e-e2c3-4b18-b776-0305e55bf745" },
      { label: "Class 6C", value: "c2ee634f-85f9-4eb3-aec0-0609d425a1a4" },
      { label: "Class 7A", value: "70e3e126-abf0-45da-8a26-238910951501" },
      { label: "Class 7B", value: "b2760032-be58-4eab-a737-d2c7bdd1e94d" },
      { label: "Class 7C", value: "3dd0965e-920f-4e9c-9966-c37933561c3f" },
      { label: "Class 8A", value: "739d1672-19a4-402a-a4c0-5c842c51ba4a" },
      { label: "Class 8B", value: "016957bf-9b7f-491f-a16d-8b53e9a1b237" },
      { label: "Class 8C", value: "ec54a59c-3854-42ed-b097-ed5261f472fd" },
      { label: "Class 9A", value: "e1b87c3c-ae98-4592-8e1c-04a963476ed8" },
      { label: "Class 9B", value: "69502ce6-2c4b-49d3-a06e-f2c9007ca9f3" },
      { label: "Class 9C", value: "8b810e00-c696-4c6e-b4d8-0d8f4ea97e8c" },
      { label: "Class 10A", value: "9a7cf558-597c-4718-b787-b89a98b160d0" },
      { label: "Class 10B", value: "63dae2ea-e8d1-475a-8042-444578594c00" },
      { label: "Class 10C", value: "30b9bd9e-c494-4a4b-85be-88125a2493bb" },
    ],
    "ff03bb7b-3ec4-4f14-9bcf-64819220c8bd": [
      { label: "Class 6A", value: "4f709f3b-f562-4be5-8ee2-f22fb4e79464" },
      { label: "Class 6B", value: "06f4159a-7a85-43f1-8864-9058547e4952" },
      { label: "Class 6C", value: "cd2334ac-24cc-4510-a70d-aaf340307b0d" },
      { label: "Class 7A", value: "7b4dccb2-46eb-408e-90b3-bc319bf7ead0" },
      { label: "Class 7B", value: "5ef3be08-f1b9-40cb-a695-07f8b3a4a9a1" },
      { label: "Class 7C", value: "c733945d-c438-4f6c-b810-6ce4eeb4e13b" },
      { label: "Class 8A", value: "e024fa83-0bab-4706-b840-292268691ee5" },
      { label: "Class 8B", value: "780cdd3d-db35-43a2-9bb0-c3de942b357f" },
      { label: "Class 8C", value: "57a28657-efba-474a-966c-c7e80822c6de" },
      { label: "Class 9A", value: "274f60ac-694e-4d93-afb1-1021ab5af05c" },
      { label: "Class 9B", value: "c41021de-50c9-42fc-a96e-2da3ecd0f7e8" },
      { label: "Class 9C", value: "58db46c8-06b3-4d33-8846-ad151b5c4791" },
      { label: "Class 10A", value: "0bdae740-824b-4a71-8d50-1ac9a1385827" },
      { label: "Class 10B", value: "e4a196e0-4598-4c71-a4e6-38edfa285832" },
      { label: "Class 10C", value: "e1f60685-ae3d-4fe5-b10f-66dd58b629d0" },
      // ... (other class options for the third org)
    ],

    "2c36a3ef-f55b-48b6-9568-eb435ec5c10f": [
      { label: "Class 6A", value: "856f2a5d-a591-469c-9926-413e7f9e0d5a" },
      { label: "Class 6B", value: "af26cb71-c999-4111-a2f9-3af66cb2894d" },
      { label: "Class 6C", value: "12736e9f-09cb-4904-8147-b57f95e665a4" },
      { label: "Class 7A", value: "b0dcb0c7-7ac8-48ef-88e1-a6d51210df40" },
      { label: "Class 7B", value: "771611c9-548c-4347-b830-3f70139a8003" },
      { label: "Class 7C", value: "0c853191-f07d-43e8-ae54-227e316410d5" },
      { label: "Class 8A", value: "264f8505-b094-44d6-9d20-12a900034d35" },
      { label: "Class 8B", value: "d58a4724-e0a0-48e8-8c39-d7f96d8e136d" },
      { label: "Class 8C", value: "6c2ed44d-dc8f-4f75-83a5-658ebf6d769e" },
      { label: "Class 9A", value: "5c783bde-789f-4d4e-ad31-1b844a46c673" },
      { label: "Class 9B", value: "2923cdbd-c8af-42a9-a5db-a05bfc859ffc" },
      { label: "Class 9C", value: "7b10993b-be6b-4f80-97b4-3a518d91cf3f" },
      { label: "Class 10A", value: "94c3493a-42b1-437d-9965-35d4323c1e68" },
      { label: "Class 10B", value: "15199299-307f-4081-ab9e-324b12bb97d8" },
      { label: "Class 10C", value: "8135ccf6-7530-4491-a5b2-fc62bc823b9f" },
      // ... (other class options for the fourth org)
    ],

    "1d1c8606-0076-4b7a-b2f6-681cb933eb16": [
      { label: "Class 6A", value: "b6e9e999-e5a1-4123-b18d-3774ebb6dba9" },
      { label: "Class 6B", value: "5bfbc64f-6f08-47ba-a67b-cfe1840e07b7" },
      { label: "Class 6C", value: "655489f6-0b00-4389-983d-698fa9e75c0e" },
      { label: "Class 7A", value: "d6d10837-a9b1-45bf-b6c6-7ce7938c57a6" },
      { label: "Class 7B", value: "f84cff1b-9bc7-4bdf-9f1b-bde96da281ee" },
      { label: "Class 7C", value: "9d8cd000-53e4-42e0-81be-12af2088c59c" },
      { label: "Class 8A", value: "9f2759ff-c6d2-4b12-be21-e97d83cf3ba9" },
      { label: "Class 8B", value: "5597c870-9fe8-48e6-97d6-fa2b82b68bf2" },
      { label: "Class 8C", value: "9e8caebc-d6a4-4185-924b-cdf03cddd03d" },
      { label: "Class 9A", value: "7d453558-195b-4540-9dec-f8c41b034428" },
      { label: "Class 9B", value: "438ff731-4f76-4aca-a70a-38c8dd9b4a6a" },
      { label: "Class 9C", value: "2c2ad181-bc74-49a4-9082-d7fbd7c3e342" },
      { label: "Class 10A", value: "c6fd19f6-5c04-4aa2-a6ba-bae997b768ca" },
      { label: "Class 10B", value: "5884234a-ac19-4380-917d-2cd3acb5469c" },
      { label: "Class 10C", value: "eadea880-bb98-41f2-b16e-569d96178564" },
      // ... (other class options for the fifth org)
    ],

    "b9f3105f-bf33-4b9a-be88-132ac4249939": [
      { label: "Class 6A", value: "f8a7d956-557f-4392-ad6d-25911df0ebd3" },
      { label: "Class 6B", value: "25c845f7-f727-48a1-8259-5175f495b865" },
      { label: "Class 6C", value: "3191e5d4-8f5d-4383-a428-f7b06f96768e" },
      { label: "Class 7A", value: "82477869-0035-4c44-9510-05a4f40b6012" },
      { label: "Class 7B", value: "ad04eef8-1f3f-40d5-9f03-bd147d966ab1" },
      { label: "Class 7C", value: "907b07f9-ab63-4545-8447-13ef458fd743" },
      { label: "Class 8A", value: "fee89823-2edc-42f5-afab-9d566b114dff" },
      { label: "Class 8B", value: "7e14cae3-2d6e-40d9-9376-09d32d8bb384" },
      { label: "Class 8C", value: "37016f8d-7cfd-4270-84f4-185b602ef8a4" },
      { label: "Class 9A", value: "c3a0938a-27f2-4fed-a8ec-a8f39c9d8e35" },
      { label: "Class 9B", value: "a192bf9e-2429-4000-9912-48627c3aaeeb" },
      { label: "Class 9C", value: "abda5731-b472-4c7a-9536-ef0baed0c20e" },
      { label: "Class 10A", value: "dc7e0484-6d68-44d1-86c3-0fed3c36395a" },
      { label: "Class 10B", value: "0bb305ea-210f-44ce-82d8-c3d594c93eb7" },
      { label: "Class 10C", value: "0c18fb30-afbb-4a8d-bac3-1961f5d9bc35" },
      // ... (other class options for the sixth org)
    ],

    "fb5911d5-fd27-44da-97ac-32b9e8f4d08c": [
      { label: "Class 6A", value: "96dccf3f-83f2-4275-983d-f63577e6a175" },
      { label: "Class 6B", value: "aa6427e0-2e21-41d0-afc2-41d3c504c2b7" },
      { label: "Class 6C", value: "08931c3b-7ae5-4d51-b825-df5edc70e21b" },
      { label: "Class 7A", value: "e0b1ce19-57a6-47a7-8d52-a9e299d0c067" },
      { label: "Class 7B", value: "dc97b754-8324-4cf7-81b5-23ad7c911b44" },
      { label: "Class 7C", value: "4b7e4ef2-b614-41f3-8d4d-26db1c3b10b0" },
      { label: "Class 8A", value: "e33cfee5-a0d4-4482-ab80-98bbb5ab09ff" },
      { label: "Class 8B", value: "35ef39f7-7421-41e9-992c-2a8133f89bf1" },
      { label: "Class 8C", value: "ad6a026c-9ae2-4f9f-99ae-8b269098c357" },
      { label: "Class 9A", value: "f3670463-1a0d-470a-af5d-b6410a8d325a" },
      { label: "Class 9B", value: "93366526-c2e8-4a04-a031-94cf6e2d8d87" },
      { label: "Class 9C", value: "8698881b-a43e-4e78-a14e-86667eefc01d" },
      { label: "Class 10A", value: "0e556b4e-5234-4f84-9924-835b9a7a7290" },
      { label: "Class 10B", value: "c6e1aa9b-2234-4655-b428-aabbb31c21ee" },
      { label: "Class 10C", value: "c319b5a5-5267-4ea2-9120-b82e384157b8" },
      // ... (other class options for the seventh org)
    ],

    "7dab8f75-349f-4044-a0ba-496bdd40e632": [
      { label: "Class 6A", value: "7616fe94-0f49-4008-9df5-410ee41d528f" },
      { label: "Class 6B", value: "2dba2863-11b2-4314-84fc-1278919fce23" },
      { label: "Class 6C", value: "95fd7aeb-b8ba-4957-9e56-ffdb4d349c16" },
      { label: "Class 7A", value: "0aeb7cc1-2a3b-41da-bfbe-47197fbd926d" },
      { label: "Class 7B", value: "735aae32-8ebf-48d6-8c56-8ceddf0fcefb" },
      { label: "Class 7C", value: "43b100d8-3fbb-44d2-9e87-94ce0b30d861" },
      { label: "Class 8A", value: "943f7370-7bb5-4694-8251-97c1603204f3" },
      { label: "Class 8B", value: "5b234ebd-2963-4156-b44e-cb412d4f7bc4" },
      { label: "Class 8C", value: "7382e5e2-05ad-48c2-acdb-061d9a4a0c7f" },
      { label: "Class 9A", value: "bde32ea2-fa80-461a-9a81-f8c791c834d5" },
      { label: "Class 9B", value: "ef713c43-6dab-47b0-af62-afba791e12f2" },
      { label: "Class 9C", value: "d4992eb4-8245-4e7c-9b03-d4880ae79373" },
      { label: "Class 10A", value: "dc7e0484-6d68-44d1-86c3-0fed3c36395a" },
      { label: "Class 10B", value: "0bb305ea-210f-44ce-82d8-c3d594c93eb7" },
      { label: "Class 10C", value: "0c18fb30-afbb-4a8d-bac3-1961f5d9bc35" },
      // ... (other class options for the eighth org)
    ],

    "95072486-cc23-4685-a35e-a6b5ea382e1c": [
      { label: "Class 6A", value: "58a6e6ed-1cc0-4f6a-9639-6b5539f88904" },
      { label: "Class 6B", value: "c916bf41-4d06-4e80-931f-42611b30fad5" },
      { label: "Class 6C", value: "5cc7d337-8b0c-45f5-baf0-d04f0db90158" },
      { label: "Class 7A", value: "79d9acc4-915c-4d29-b2b9-4944509a2130" },
      { label: "Class 7B", value: "769cf65f-2203-4caf-b71e-38c0bd21e00a" },
      { label: "Class 7C", value: "b65be2bd-69f6-4235-9635-679f20511b2b" },
      { label: "Class 8A", value: "04896012-2b7a-4afd-ba71-b48e5aed3e9c" },
      { label: "Class 8B", value: "3e9a7f0e-3a93-4622-b45c-d3f4d9d4885f" },
      { label: "Class 8C", value: "d757a25a-2226-42e2-9559-843dad699a1e" },
      { label: "Class 9A", value: "994a52b4-dd33-409a-982e-c2a914b7eebb" },
      { label: "Class 9B", value: "2572c850-50ac-465a-b2d1-8c32337c49e3" },
      { label: "Class 9C", value: "7108ddae-2a10-4e9e-8871-7f702a747226" },
      { label: "Class 10A", value: "3420e948-37d0-4768-a635-f7e5bb7a1a7e" },
      { label: "Class 10B", value: "9d35c228-edd9-4b0e-889f-eb6a615a175f" },
      { label: "Class 10C", value: "19bac33c-b86f-4197-a99c-b98b686c3577" },
      // ... (other class options for the ninth org)
    ],

    // Add more organizations as needed
  };

  const [importedData, setImportedData] = useState([]);
  const [users, setUsers] = useState([]);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [userType, setUserType] = useState("Student");
  const [recordsAdded, setRecordsAdded] = useState(0); // State variable to store the number of records added

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async (event) => {
      const content = event.target.result;
      const data = parseCSV(content);
      setImportedData(data);
    };

    reader.readAsText(file);
  };

  const parseCSV = (content) => {
    const rows = content.trim().split("\n");
    const headers = rows[0].split(",");
    const data = [];

    for (let i = 1; i < rows.length; i++) {
      const values = rows[i].split(",");
      const row = {};
      for (let j = 0; j < headers.length; j++) {
        row[headers[j]] = values[j];
      }
      data.push(row);
    }

    return data;
  };

  const handleImport = async () => {
    try {
      console.log("Imported Data:", importedData);
      const newUsers = [];

      if (importedData.length === 0) {
        console.error("No data to import.");
        return;
      }

      for (const userData of importedData) {
        const response = await axios.post(
          'http://localhost:3000/organizations/api/users',
          {
            orgId: orgId,
            userType: userType,
            classId: classOptionsByOrg[orgId].find(option => option.label === userData.Class)?.value || "",
            admissionId: null,
            transportRouteId: null,
            userDetails: {
              firstname: userData["First Name"],
              lastname: userData["Last Name"],
              gender: userData.Gender,
              dateOfBirth: userData["Date of Birth"],
              address: {
                addressLine1: userData["Address Line 1"],
                addressLine2: userData["Address Line 2"],
                city: userData.City,
                state: null,
                pincode: null,
              },
              contact: {
                email: userData.Email,
                phone: userData.Phone,
              },
              geoCodeInfo: {
                latitude: null,
                longitude: null,
                source: null,
                accuracy: null,
              },
              imageUrl: null,
            },
            paymentsRecord: null,
            token: null,
          },
          {
            headers: {
                Authorization: "YourAuthorizationTokenHere",
              },
          }
        );

        if (response.status === 200) {
          console.log("User created successfully:", userData);
          newUsers.push(response.data);
        } else {
          console.error("Failed to create user:", response.data);
        }
      }

      setUsers([...users, ...newUsers]);
      setUploadSuccess(true);
      setRecordsAdded(newUsers.length); // Update the number of records added
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  const downloadTemplate = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = "../../assets/data - Sheet1.csv";
    downloadLink.download = "data_template.csv";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  
 
  return (
    <div>
      <div className="data-container">
        <h3>About organization</h3>
        <div className="data-column">
          <div className="button-row">
            <div>
            <h3>Students</h3>
            </div>
            <input type="file" onChange={handleFileChange} accept=".csv" />
            <div className='onlybtn'>
            <button onClick={() => { setUserType("Student"); handleImport(); }}>Upload</button>
            <button>Download</button>
            <button onClick={downloadTemplate}>Download template</button>
            </div>
           <div>
            {uploadSuccess && <p className="success-message">{recordsAdded} Records added</p>}
            </div>
          </div>
        </div>
        <div className="data-column">
          <div className="button-row">
            <h3>Faculty</h3>
            <input type="file" onChange={handleFileChange} accept=".csv" />
            <div className='onlybtn'>
            <button >Upload</button>
            <button>Download</button>
            <button>Download template</button>

            </div>
            <div>
            {/* {uploadSuccess && <p>{recordsAdded} records added</p>} */}
            </div>
                      </div>
        </div>
        {/* Other sections */}
      </div>
      {uploadSuccess && <p className="success-message">Upload successful!</p>}
    </div>
  );
};

export default Data;
